import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/OG9";

const Og9 = () => { // Renamed component from OasisGardens to Og9 to match file name and avoid confusion, though original was OasisGardens
  const project_id = "PRJ00041";
  const title = "The Great Oasis Gardens - Nanyuki"; // Same title as OG

  const mapConfig = {
    minZoom: 10,
    zoom: 12,
    bounds: [
      [40.84, -74.18],
      [40.55, -73.94],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={project_id}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/the-great-oasis-gardens-nanyuki/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSfkovo3n5xt2iggBTQeHIaa98TI6-XbUXTPeTBc2XoGLdRwOg/viewform"
    />
  );
};

export default Og9; // Exporting as default, so name change is local
